module.exports = __webpack_public_path__ + "media/featured/GH-142133d2.png";